<template>
  <action-dispatcher
    class="view-podcasts py-5 text-light"
    action="podcasts/getPodcasts"
  >
    <div class="container">
      <h5>Podcasts</h5>
      <div class="row">
        <div
          class="col-lg-3 col-md-4 col-6 py-3"
          v-for="podcast in podcasts"
          :key="podcast.id"
        >
          <podcast-slide :podcast="podcast" />
        </div>
      </div>
    </div>
  </action-dispatcher>
</template>

<script>
import PodcastSlide from "@/components/home/PodcastSlide";
import { mapState } from "vuex";

export default {
  components: { PodcastSlide },
  computed: {
    ...mapState("podcasts", ["podcasts"])
  }
};
</script>
